import { WorkloadTableItem } from "../../../../mst/kinds/workload.helpers";
import { TableColumn } from "../../types";

const minScaleDefault = { id: "minScale", label: "Min Scale" };
export function WorkloadMinScaleColumn<TData extends WorkloadTableItem>(column: TableColumn<TData> = minScaleDefault) {
  const preset: TableColumn<TData> = {
    ...minScaleDefault,
    enableHide: true,
    hiddenByDefault: true,
    size: 130,
    cell: (p) => {
      const workload = p.row.original;

      return <span>{workload.minScale === undefined ? "" : workload.minScale}</span>;
    },
  };
  return Object.assign(preset, column);
}
